import React, { useEffect, useState } from 'react'

import { Icon, ChevronRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, array, shape, bool } from 'prop-types'

import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'
import useListingCategoryNavigation from 'Pods/UnifiedNavigation/Shared/Hooks/useListingCategoryNavigation'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'
import useBreakpoint from 'Utils/useBreakpoint'

import SubcategoryMenu from './Components/SubcategoryMenu/SubcategoryMenu'
import { useSubcategoryMenu } from './Hooks/useSubcategoryMenu'

function AssetItem({ title, icon, href, subcategories = EMPTY_ARRAY, actionsConfig = EMPTY_OBJECT }) {
  const {
    isSubmenuOpen,
    hoverZoneRef,
    handleArrowClick,
    handleCloseSubmenu,
    handleHoverZoneMouseEnter,
    handleHoverZoneMouseLeave,
    handleSubmenuFocus,
    handleSubmenuBlur,
  } = useSubcategoryMenu()

  const breakpoint = useBreakpoint()
  const isMobileBreakpoint = ['xs', 'sm'].includes(breakpoint)
  // useBreakpoint returns undefined at SSR but the real breakpoint on the first client render.
  // Gate the value behind hydration so the first client render matches the server (isMobile=false),
  // otherwise the divergent chevron markup below tears down and re-renders the whole navbar via
  // flushSync on mobile (innerWidth < 960). Mirrors the Search component's hasHydrated guard.
  const [hasHydrated, setHasHydrated] = useState(false)
  const isMobile = hasHydrated ? isMobileBreakpoint : false

  useEffect(() => {
    setHasHydrated(true)
  }, [])

  const handleLinkClick = useListingCategoryNavigation({ isMobile })

  // TODO: Remove when subscription menu is live
  const subscriptionMenuEnabled = actionsConfig?.subscriptionMenuEnabled
  const subscriptionFlowEnabled = actionsConfig?.subscriptionFlowEnabled
  const shouldHide = icon === 'subscription' && (!subscriptionMenuEnabled || !subscriptionFlowEnabled)

  if (shouldHide) {
    return null
  }

  return (
    <div
      className="asset-item"
      onMouseEnter={handleHoverZoneMouseEnter}
      onMouseLeave={handleHoverZoneMouseLeave}
      onFocus={handleSubmenuFocus}
      onBlur={handleSubmenuBlur}
      ref={hoverZoneRef}
    >
      <a className="asset-item__link" href={href} onClick={(event) => handleLinkClick(event, href)}>
        <ModelIcon icon={icon} width="24" height="24" />
        <span className="asset-item__title">{title}</span>

        {!isMobile && subcategories && subcategories.length > 0 && (
          <Icon color="dark" size="small" svgComponent={ChevronRight} className="asset-item__arrow" />
        )}
      </a>

      {isMobile && subcategories && subcategories.length > 0 && (
        <Icon
          color="dark"
          size="small"
          svgComponent={ChevronRight}
          className="asset-item__arrow"
          style={{ cursor: 'pointer' }}
          onClick={handleArrowClick}
        />
      )}

      {subcategories && subcategories.length > 0 && (
        <SubcategoryMenu
          subcategories={subcategories}
          categoryTitle={title}
          isOpen={isSubmenuOpen}
          onClose={handleCloseSubmenu}
          handleLinkClick={handleLinkClick}
        />
      )}
    </div>
  )
}

AssetItem.propTypes = {
  title: string.isRequired,
  icon: string.isRequired,
  href: string,
  subcategories: array,
  actionsConfig: shape({
    subscriptionMenuEnabled: bool,
    subscriptionFlowEnabled: bool,
    isActiveSubscriber: bool,
  }),
}

export default AssetItem
